export const contactInfo = {
    mailTo: "woodshedfurniture@gmail.com",
    phone: "360 491 0700",
    page: "/page/contact",
    facebook: "https://www.facebook.com/people/Woodshed-Furniture/100085962295415/",
    instagram: "https://www.instagram.com/woodshed_furniture/",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: "",
    tiktok: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: "Have questions or need assistance? We're here to help! Whether you're looking for the perfect piece of furniture or need mattress recommendations, feel free to send us a message, and we'll get back to you as soon as possible",
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledgeable staff would be delighted to help you.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: 'Woodshed Furniture has been serving Thurston County since 1973. Shop our large selection of upholstered furniture, bedroom sets, dining sets, bookcases, office furniture, tv stands, recliners and more.',
    where: {
        title: 'WHERE WE OPERATE',
        subtitle: '6127 Martin Way Lacey, Wa 98516',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2718.5204621039065!2d-122.80570010734829!3d47.049639896741915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54910b72abfe1e2f%3A0xe982bc87cdf4b77!2sWoodshed%20Furniture!5e0!3m2!1sen!2suy!4v1748279363246!5m2!1sen!2suy'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday 9:30am - 6:00pm /  Saturday 9:30am - 5:00pm'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}